import request from '@/utils/request'

const busUrl = window.g.baseURL1

// 管理员发送验证码
export function send (query) {
  return request({
    url: busUrl + '/send',
    method: 'post',
    params: query
  })
}

//管理员登录
export function login (type = 0, query) {
  let params = type == 0 ? '/login' : '/login2';
  return request({
    url: busUrl + params,
    method: 'post',
    params: query
  })
}

//管理员退出
export function exit () {
  return request({
    url: busUrl + '/exit',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js